import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { IcmTab } from '../components/IcmTab';

export default function IcmPage({ user }) {
  return (
    <div className="min-h-screen bg-background-base text-white" data-testid="icm-page">
      <header className="sticky top-0 z-20 bg-background-base/95 backdrop-blur border-b border-white/[0.06]">
        <div className="max-w-[1200px] mx-auto px-3 sm:px-6 h-12 flex items-center justify-between">
          <Link to="/admin" className="inline-flex items-center gap-1.5 text-xs font-heading tracking-wider uppercase text-white/60 hover:text-white" data-testid="icm-back-link">
            <ArrowLeft className="w-4 h-4" /> Admin
          </Link>
          <span className="font-heading text-sm tracking-wider text-primary-main">RDPT+ ICM DEAL</span>
          <span className="text-[11px] text-white/40 truncate max-w-[40%]">{user?.email}</span>
        </div>
      </header>
      <main className="max-w-[1200px] mx-auto px-3 sm:px-6 py-4 sm:py-6">
        <IcmTab token={user?.token} fullscreen />
      </main>
    </div>
  );
}
